import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Box, Flex, Button, Image, Avatar, Text, useColorMode, Stack, Grid, GridItem, Stat, StatLabel, StatNumber, Icon, useDisclosure, Badge, useColorModeValue, Progress, Select, ButtonGroup, SimpleGrid, Input, IconButton, useToast } from "@chakra-ui/react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine, Cell } from 'recharts';
import { FaWalking, FaHeart, FaWeight, FaRulerVertical, FaHeartbeat, FaArrowLeft,FaEdit, FaTrash, FaPlus  } from "react-icons/fa";

import { BiBarChart, BiLineChart } from 'react-icons/bi';
import Logo from "../fitness.png";
import Loading from "./Loader";
import GaugeChart from 'react-gauge-chart';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";

import { Skeleton, SkeletonText } from "@chakra-ui/react"; 
import id from 'date-fns/locale/id';
registerLocale('id', id);


const user = JSON.parse(localStorage.getItem('user')); 

const DashboardMeal = () => {
  const navigate = useNavigate();
  const toast = useToast();
  
  

  const [plan30Hari, setPlan30Hari] = useState([]);

  // 1. HELPER DULU - sebelum useState
  const parseDateString = (tglString) => {
    if (!tglString) return null;
    const tahun = new Date().getFullYear();
    const bulanMap = { Jan:0, Feb:1, Mar:2, Apr:3, Mei:4, Jun:5, Jul:6, Agu:7, Sep:8, Okt:9, Nov:10, Des:11 };
    const parts = tglString.split(', ')[1]?.split(' ');
    if (!parts) return null;
    const day = parseInt(parts[0]);
    const month = bulanMap[parts[1]];
    return new Date(tahun, month, day);
  };
const dayRefs = useRef([]); // <- buat scroll ke tiap hari

  const formatDateString = (date) => {
  if (!date || isNaN(date.getTime())) return '-';
  const hari = ['Min','Sen','Sel','Rab','Kam','Jum','Sab'];
  const bulan = ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'];
  return `${hari[date.getDay()]}, ${date.getDate()} ${bulan[date.getMonth()]}`;
};



  
  const formatDateToMySQL = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };



const parseMySQLDate = (dateStr) => {
  if (!dateStr) return null;
  // DB kamu simpan "2026-05-27T17:00:00.000Z" bukan "2026-05-27"
  const dateOnly = dateStr.split('T')[0]; // ambil "2026-05-27" aja
  const [y, m, d] = dateOnly.split('-').map(Number);
  return new Date(y, m-1, d);
};


  // 2. SEMUA STATE - setelah helper
  const today = new Date();
  const [userEmail, setUserEmail] = useState('');
  const [selectedDateMYSQL, setSelectedDateMYSQL] = useState(formatDateToMySQL(today));
  const [selectedDate, setSelectedDate] = useState(formatDateString(today));
  const [bmi, setBmi] = useState(0);
  const [bmiCategory, setBmiCategory] = useState('');
  const [bmiColor, setBmiColor] = useState('#718096');
  const [selectedMenus, setSelectedMenus] = useState({});
  const [mealPlans, setMealPlans] = useState([]);
  const [savingMeal, setSavingMeal] = useState(false);
  const [deletingMeal, setDeletingMeal] = useState(false);
  const [fitnessData, setFitnessData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [jumlahHari, setJumlahHari] = useState(7);
  const [chartType, setChartType] = useState('bar');
  const [latestWeight, setLatestWeight] = useState(0);
  const [latestHeight, setLatestHeight] = useState(0);
  const [selectedData, setSelectedData] = useState(null);
  const [mysqlData, setMysqlData] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [planStatus, setPlanStatus] = useState({}); 

  const componentRef = useRef();
  const { colorMode, toggleColorMode } = useColorMode();
  const cardBg = useColorModeValue("orange.50", "orange.300");

  const showToast = (title, status = 'success') => {
    toast({ title, status, duration: 3000, isClosable: true, position: 'top-right' });
  };


  
  // 3. useEffect Load userEmail
  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    if (email) setUserEmail(email);
    else navigate('/login');
  }, [navigate]);

  // 4. useEffect Load meal plan
  useEffect(() => {
    if (userEmail && selectedDateMYSQL) {
      loadSavedMealPlan();
    }
  }, [userEmail, selectedDateMYSQL]);

  // 5. CUMA 1 HANDLE SAVE - hapus yang duplikat bawah
 const handleSaveMealPlan = async () => {
  if (!userEmail) return showToast('Login dulu', 'warning');

  // Validasi menu kepilih semua
  const missing = [];
  for (let i = 0; i < mealPlans.length; i++) {
    if (!selectedMenus.hasOwnProperty(i)) missing.push(i + 1);
  }

  if (missing.length > 0) {
    const hariText = missing.length === 1
     ? `Hari ${missing[0]}`
      : `Hari ${missing.slice(0, -1).join(', ')} & ${missing.slice(-1)}`;
    return showToast(`Pilih menu dulu untuk ${hariText}`, 'warning');
  }

  setSavingMeal(true);
  try {
    const startDate = mealPlans[0].dateMySQL;
    const endDate = mealPlans[mealPlans.length - 1].dateMySQL;

    // 1. CEK OVERLAP DULU
    const check = await axios.get(`${process.env.REACT_APP_API_BASE}/check-overlap-meal-plan`, {
      params: {
        email: userEmail,
        start_date: startDate,
        end_date: endDate
      }
    });

    if (check.data.success && check.data.overlap) {
      const plan = check.data.plans[0];
      // Format tanggal bentrok jadi "tgl 7, tgl 8"
      const tglBentrok = plan.bentrok_tanggal
       .split(',')
       .map(t => 'tgl ' + t.split('-')[2])
       .join(', ');
  const startDateClean = plan.start_date.toString().slice(0, 10);
  const endDateClean = plan.end_date.toString().slice(0, 10);
      const confirmMsg = `Bentrok data meal plan ${tglBentrok}.\n\n` +
                 `Confirmasi\nHapus data plan ${startDateClean} s.d ${endDateClean}?`;


      if (!window.confirm(confirmMsg)) {
        setSavingMeal(false);
        return showToast('Save dibatalkan', 'info');
      }
    }

    // 2. BUILD RECORDS KALAU GAK BENTROK ATAU USER CONFIRM
    const records = mealPlans.map((plan, idx) => {
      const menuIdx = selectedMenus[idx];
      const selectedMenu = plan.menus[menuIdx];
      return {
        userEmail,
        tanggal: plan.dateMySQL,
        meal_plan: selectedMenu.items, // <- jangan stringify disini, biar backend yang stringify
        total_kkal: selectedMenu.total,
        target_kkal: plan.target,
        menu_variant: menuIdx + 1,
        kategori_bmi: bmiCategory.toLowerCase()
      };
    });

    // 3. POST KE BACKEND
    const res = await axios.post(`${process.env.REACT_APP_API_BASE}/update-meal-plan-batch`, { records });

    if(res.data.success) {
      showToast(`Berhasil simpan meal plan ${mealPlans[0].date} s/d ${mealPlans[7].date}`, 'success');
      loadSavedMealPlan(); // reload biar UI update
    }
  } catch(err) {
    console.error('Save error:', err);
    showToast('Gagal simpan: ' + err.response?.data?.error || err.message, 'error');
  } finally {
    setSavingMeal(false);
  }
};
  //... sisanya function loadSavedMealPlan, handleDelete, dsb taruh di bawah sini
  // JANGAN ada kode ngambang const/return di luar function


const loadMealPlanStatus = async (startDate, endDate) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE}/meal-plan-status`, {
      params: { email: userEmail, start_date: startDate, end_date: endDate }
    });
    setPlanStatus(res.data.statusMap || {});
  } catch (err) {
    console.error('Gagal load status:', err);
  }
};




const { isOpen, onOpen, onClose } = useDisclosure();





  // FUNGSI HELPER
  

  
 

  //

  // DATA DERIVED
  const dataChart = fitnessData?.data || [];
  const tanggalAdaData = dataChart
  .map(d => parseDateString(d.tanggal)?.toDateString())
  .filter(Boolean);

  const minDate = new Date();
  minDate.setDate(today.getDate() - 90);

  const filterTanggal = (date) => {
    if (dataChart.length > 0) {
      return tanggalAdaData.includes(date.toDateString());
    }
    return date >= minDate && date <= today;
  };

  const handleGantiTanggalKalender = (date) => {
    const tglMYSQL = formatDateToMySQL(date);
    const tglDisplay = formatDateString(date).trim(); 
    setSelectedDateMYSQL(tglMYSQL);
    setSelectedDate(tglDisplay);
    setSelectedData(dataChart.find(d => d.tanggal === tglDisplay) || null);
   
  };




  const handleGantiHari = (e) => {
    const hari = parseInt(e.target.value);
    setJumlahHari(hari);
    if (userEmail) {
      fetchHistoryFromDB(hari);
    }
  };

const user = JSON.parse(localStorage.getItem('user')); 
// asumsi pas login: localStorage.setItem('user', JSON.stringify({email: 'jakaria216@gmail.com', name: 'Jakaria'}))






  useEffect(() => {
    if (!userEmail ||!selectedDateMYSQL) return;
    const fetchDataByDate = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE}/health-by-date`, {
          params: { email: userEmail, date: selectedDateMYSQL }
        });
        setMysqlData(res.data);
      } catch (err) {
        console.error('Gagal ambil data MySQL:', err);
        setMysqlData(null);
       } finally {
      setIsLoading(false);
      }
    };
    fetchDataByDate();
  }, [userEmail, selectedDateMYSQL]);

  useEffect(() => {
    if (dataChart.length > 0) {
      const last = dataChart[dataChart.length - 1];
      setSelectedDate(last.tanggal);
      setSelectedData(last);
    }
  }, [dataChart]);

  const getLastWeightHeight = (targetDate) => {
    if (!dataChart.length ||!targetDate) return { weight: latestWeight, height: latestHeight, tanggal: null };
    const validData = dataChart
    .filter(d => d.tanggal <= targetDate && d.weight > 0 && d.height > 0)
    .sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
    if (validData.length > 0) {
      return {
        weight: validData[0].weight,
        height: validData[0].height,
        tanggal: validData[0].tanggal
      };
    }
    return { weight: latestWeight, height: latestHeight, tanggal: null };
  };

  const lastWeightHeight = getLastWeightHeight(selectedDate);
  const displaySteps = mysqlData?.langkah?? selectedData?.langkah?? 0;
  const displayHeartRate = mysqlData?.heart_rate?? selectedData?.heart_rate?? 0;
  const displayCardio = mysqlData?.poin_kardio?? selectedData?.poin_kardio?? 0;
  const displayWeight = mysqlData?.weight?? selectedData?.weight?? lastWeightHeight.weight?? 0;
  const displayHeight = mysqlData?.height?? selectedData?.height?? lastWeightHeight.height?? 0;

  const calculateBmiByDate = () => {
    if (!displayWeight ||!displayHeight) return { bmi: 0, category: 'Tidak ada data', color: '#718096' };
    const bmiValue = displayWeight / ((displayHeight / 100) * (displayHeight / 100));
    let category = '';
    let color = '';
    if (bmiValue < 18.5) { category = 'Underweight'; color = '#3182CE'; }
    else if (bmiValue < 25) { category = 'Normal'; color = '#38A169'; }
    else if (bmiValue < 30) { category = 'Overweight'; color = '#ECC94B'; }
    else if (bmiValue < 35) { category = 'Obese I'; color = '#ED8936'; }
    else { category = 'Obese II'; color = '#E53E3E'; }
    return { bmi: bmiValue, category, color };
  };

  const displayBmiData = calculateBmiByDate();
  const displayBmi = displayBmiData.bmi;
  const displayBmiCategory = displayBmiData.category;
  const displayBmiColor = displayBmiData.color;

  const getHealthScoreByDate = () => {
    const data = mysqlData || selectedData;
    if (!data) return { label: 'Belum Ada Data', color: 'gray', persen: 0 };
    let skor = 0;
    const bmiValue = displayWeight && displayHeight? displayWeight / ((displayHeight / 100) * (displayHeight / 100)) : 0;
    if (bmiValue >= 18.5 && bmiValue < 25) skor += 20;
    else if (bmiValue >= 25 && bmiValue < 30) skor += 10;
    if (data.langkah >= 10000) skor += 20;
    else if (data.langkah >= 7500) skor += 15;
    else if (data.langkah >= 5000) skor += 10;
    if (data.resting_heart_rate >= 60 && data.resting_heart_rate <= 100) skor += 20;
    else if (data.resting_heart_rate > 0) skor += 10;
    const jamTidur = (data.sleepMinutes || 0) / 60;
    if (jamTidur >= 7 && jamTidur <= 9) skor += 20;
    else if (jamTidur >= 6) skor += 10;
    if (data.menitAktif >= 22) skor += 20;
    else if (data.menitAktif >= 11) skor += 10;
    const persen = Math.round(skor);
    if (persen >= 80) return { label: 'Sangat Sehat', color: 'green', persen };
    if (persen >= 60) return { label: 'Sehat', color: 'teal', persen };
    if (persen >= 40) return { label: 'Cukup', color: 'orange', persen };
    return { label: 'Kurang Sehat', color: 'red', persen };
  };

  const displayHealthScore = getHealthScoreByDate();

  const getHealthDetail = () => {
    const data = mysqlData || selectedData;
    if (!data) return [];
    const healthDetail = [
      {
        indikator: 'BMI',
        aktual: displayBmi >= 18.5 && displayBmi < 25? 100 : displayBmi >= 25 && displayBmi < 30? 50 : 0,
        target: 100,
        nilai: displayBmi? displayBmi.toFixed(1) : '-',
        satuan: ''
      },
      {
        indikator: 'Langkah',
        aktual: Math.min(100, Math.round((data.langkah || 0) / 100)),
        target: 100,
        nilai: data.langkah || 0,
        satuan: ' langkah'
      },
      {
        indikator: 'RHR',
        aktual: data.resting_heart_rate >= 60 && data.resting_heart_rate <= 100? 100 : data.resting_heart_rate > 0? 50 : 0,
        target: 100,
        nilai: data.resting_heart_rate || '-',
        satuan: ' bpm'
      },
      {
        indikator: 'Tidur',
        aktual: Math.min(100, Math.round(((data.sleepMinutes || 0) / 60) / 8 * 100)),
        target: 100,
        nilai: data.sleepMinutes? `${Math.floor(data.sleepMinutes/60)}j ${data.sleepMinutes%60}m` : '-',
        satuan: ''
      },
      {
        indikator: 'Kardio',
        aktual: Math.min(100, Math.round((data.menitAktif || 0) / 22 * 100)),
        target: 100,
        nilai: data.menitAktif || 0,
        satuan: ' poin'
      },
      {
        indikator: 'Oksigen',
        aktual: data.oxygen_saturation >= 95? 100 : data.oxygen_saturation >= 90? 70 : 0,
        target: 100,
        nilai: data.oxygen_saturation || '-',
        satuan: '%'
      }
    ];
    return healthDetail;
  };

  const healthDetail = getHealthDetail();

  // STATE HISTORY
  
  

  const fetchHistoryFromDB = async (days) => {
    if (!userEmail) return;
    setHistoryLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/health-history`, {
        params: { email: userEmail, days: days }
      });
      const cleanData = (res.data?.data || []).map(d => ({...d}));
      setHistoryData(cleanData);
    } catch (err) {
      console.error('Gagal ambil history:', err);
      setHistoryData([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (userEmail) fetchHistoryFromDB(jumlahHari);
  }, [userEmail, jumlahHari]);


  




const [planHeader, setPlanHeader] = useState(null); // {start_date, end_date, target_kkal}
const [isExistingPlan, setIsExistingPlan] = useState(false);



const loadSavedMealPlan = async () => {
  if (!userEmail ||!selectedDateMYSQL) return;
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE}/load-meal-plan`, {
      params: { email: userEmail.trim().toLowerCase(), date: selectedDateMYSQL }
    });
    const { success, data } = res.data;

    if (success && data?.header && data?.details?.length > 0) {
      setPlanHeader(data.header);
      setIsExistingPlan(true);
      
      const startDate = parseMySQLDate(data.header.start_date); // parse manual
      generateMealPlans(startDate, data.header.target_kkal, data.details);

      const selectedObj = {};
      data.details.forEach(d => {
        selectedObj[d.day_number - 1] = d.menu_variant - 1;
      });
      setSelectedMenus(selectedObj);
    } else {
      setPlanHeader(null);
      setIsExistingPlan(false);
      setSelectedMenus({});
      const startDate = parseMySQLDate(selectedDateMYSQL);
      generateMealPlans(startDate, null);
    }

    
  } catch(err) {
    console.error(err);
  }
};


 

  //const baseMenus = [
  //  [{waktu:'Sarapan',menu:'Oatmeal 50g + pisang 1 + telur 2',kkal:420},{waktu:'Snack Pagi',menu:'Apel 1 + almond 15g',kkal:180},{waktu:'Makan Siang',menu:'Nasi merah 150g + ayam 120g + sayur 200g',kkal:580},{waktu:'Snack Sore',menu:'Yoghurt Greek 150g',kkal:120},{waktu:'Makan Malam',menu:'Nasi 120g + ikan tongkol 120g + kangkung 150g + tahu 100g',kkal:500}],
  //  [{waktu:'Sarapan',menu:'Roti gandum 2 + alpukat 50g + telur orak 2',kkal:450},{waktu:'Snack Pagi',menu:'Jeruk 1 + kacang tanah 20g',kkal:180},{waktu:'Makan Siang',menu:'Pasta gandum 150g + sapi 120g + salad',kkal:600},{waktu:'Snack Sore',menu:'Susu low fat 200ml + biskuit 2',kkal:150},{waktu:'Makan Malam',menu:'Kentang rebus 200g + salmon 120g + brokoli',kkal:480}],
  //  [{waktu:'Sarapan',menu:'Sereal 40g + susu 250ml + pisang 1',kkal:380},{waktu:'Snack Pagi',menu:'Yoghurt plain 150g',kkal:120},{waktu:'Makan Siang',menu:'Nasi 150g + tempe 100g + buncis 200g',kkal:550},{waktu:'Snack Sore',menu:'Telur rebus 2',kkal:140},{waktu:'Makan Malam',menu:'Mie shirataki 150g + ayam 100g + sop sayur',kkal:420}]
 // ];

const generateMealPlans = (startDate, targetFromDB, detailsFromDB = null) => {
  if (!displayWeight ||!displayHeight) return;

  const heightM = displayHeight / 100;
  const bmi = displayWeight / (heightM * heightM);
  let kategori = 'normal';
  if (bmi < 18.5) kategori = 'underweight';
  else if (bmi >= 25) kategori = 'overweight';

  const bmr = 10*displayWeight + 6.25*displayHeight - (kategori==='normal'?161:-5);
  const tdee = Math.round(bmr * 1.55);
  const targetKalori = targetFromDB || (kategori === 'overweight'? tdee - 500 : kategori === 'underweight'? tdee + 400 : tdee);

  let plans;

  if (detailsFromDB && detailsFromDB.length > 0) {
    console.log('RAW DB:', JSON.stringify(detailsFromDB, null, 2));

    plans = detailsFromDB.map(d => {
      const dateObj = parseMySQLDate(d.tanggal);
      let menusParsed = [];

      try {
        let parsed = d.meal_plan;
        if (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
          if (typeof parsed === 'string') parsed = JSON.parse(parsed);
        }

        // Kasus 1: DB simpan 1 menu
        if (Array.isArray(parsed) && parsed[0]?.waktu) {
          const satuMenu = parsed.map(item => ({
            waktu: item.waktu,
            menu: item.menu || item.nama || '-',
            kkal: item.kkal || item.kalori || 0
          }));
          const total = satuMenu.reduce((s,m)=>s+m.kkal,0);
          menusParsed = [
            {items: satuMenu, total},
            {items: [...satuMenu], total},
            {items: [...satuMenu], total}
          ];
        }
        // Kasus 2: DB udah 3 menu
        else if (Array.isArray(parsed) && parsed[0]?.items) {
          menusParsed = parsed.map(v => ({
            items: (v.items || []).map(item => ({
              waktu: item.waktu,
              menu: item.menu || item.nama || '-',
              kkal: item.kkal || item.kalori || 0
            })),
            total: v.total || 0
          }));
        }
        else {
          menusParsed = [{items: [], total: 0}];
        }
      } catch(e) {
        menusParsed = [{items: [{waktu:'Error', menu: 'Data korup', kkal: 0}], total: 0}];
      }

      return {
        day: d.day_number,
        date: formatDateString(dateObj),
        dateMySQL: d.tanggal,
        menus: menusParsed,
        target: targetKalori
      };
    });

    console.log('Final plans:', JSON.stringify(plans, null, 2));
    setMealPlans(plans); // <- INI YANG KEMARIN KETINGGALAN

  } else {
    // MODE BARU - generate 8 hari
    const baseMenus = [
      [{waktu:'Sarapan',menu:'Oatmeal 50g + pisang 1 + telur 2',kkal:420},{waktu:'Snack Pagi',menu:'Apel 1 + almond 15g',kkal:180},{waktu:'Makan Siang',menu:'Nasi merah 150g + ayam 120g + sayur 200g',kkal:580},{waktu:'Snack Sore',menu:'Yoghurt Greek 150g',kkal:120},{waktu:'Makan Malam',menu:'Nasi 120g + ikan tongkol 120g + kangkung 150g + tahu 100g',kkal:500}],
      [{waktu:'Sarapan',menu:'Roti gandum 2 + alpukat 50g + telur orak 2',kkal:450},{waktu:'Snack Pagi',menu:'Jeruk 1 + kacang tanah 20g',kkal:180},{waktu:'Makan Siang',menu:'Pasta gandum 150g + sapi 120g + salad',kkal:600},{waktu:'Snack Sore',menu:'Susu low fat 200ml + biskuit 2',kkal:150},{waktu:'Makan Malam',menu:'Kentang rebus 200g + salmon 120g + brokoli',kkal:480}],
      [{waktu:'Sarapan',menu:'Sereal 40g + susu 250ml + pisang 1',kkal:380},{waktu:'Snack Pagi',menu:'Yoghurt plain 150g',kkal:120},{waktu:'Makan Siang',menu:'Nasi 150g + tempe 100g + buncis 200g',kkal:550},{waktu:'Snack Sore',menu:'Telur rebus 2',kkal:140},{waktu:'Makan Malam',menu:'Mie shirataki 150g + ayam 100g + sop sayur',kkal:420}]
    ];

    plans = Array.from({length: 8}, (_, i) => {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      return {
        day: i+1,
        date: formatDateString(date),
        dateMySQL: formatDateToMySQL(date),
        menus: baseMenus.map(menu => ({
          items: menu,
          total: menu.reduce((s,m)=>s+m.kkal,0)
        })),
        target: targetKalori
      };
    });
    setMealPlans(plans); // <- ini udah ada
  }
};


const formatMYSQL = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};


const handleDeleteMealPlan = async () => {
  if (!userEmail) return showToast('Login dulu', 'warning');

  const dateToDelete = formatMYSQL(selectedDateMYSQL); // <- format dulu
  console.log('DELETE kirim:', { email: userEmail, date: dateToDelete }); // <- debug

  const confirm = window.confirm(`Hapus meal plan ${mealPlans[0]?.date} s/d ${mealPlans[7]?.date}?`);
  if (!confirm) return;

  setDeletingMeal(true);
  try {
    const res = await axios.delete(`${process.env.REACT_APP_API_BASE}/delete-meal-plan`, {
      params: { email: userEmail.trim().toLowerCase(), date: dateToDelete } // <- trim + lowercase email
    });

    const { success, message } = res.data;
    if (success) {
      showToast('Meal plan berhasil dihapus', 'success');
      setSelectedMenus({});
      setMealPlans([]);
    } else {
      showToast(message || 'Gagal hapus', 'info');
    }
  } catch (err) {
    console.error(err); // <- log full error
    showToast('Gagal hapus: ' + err.message, 'error');
  } finally {
    setDeletingMeal(false);
  }
};

  return (
    <>
      {isLoading? (
        <Loading />
      ) : (
      <Box>
        {/* === HEADER STICKY - INI WAJIB ADA === */}
        <Box bg={colorMode === "light"? "black" : "pink.800"} px={{ base: 2, md: 4 }} py={2} color="white" position="sticky" top={0} zIndex={10}>
          <Flex align="center" justify="space-between" wrap="wrap" gap={2}>
            {/* Kiri: Logo + Judul */}
            <Flex align="center" flexShrink={0}>
              <Image src={Logo} alt="Logo" boxSize={{ base: "28px", md: "40px" }} mr={2} />
              <Box>
                <Text fontSize={{ base: "sm", md: "lg" }} fontWeight="bold" lineHeight="1">Meal Plan</Text>
                <Text fontSize={{ base: "xs", md: "sm" }} lineHeight="1">Dashboard</Text>
              </Box>
            </Flex>

            {/* Kanan: DatePicker + Email + Kembali + Darkmode */}
            <Flex align="center" gap={{ base: 1, md: 2 }} flexWrap="wrap" justify="flex-end" flex="1" minW={0}>
              
              {/* DatePicker untuk select tanggal */}
              <DatePicker
                selected={parseDateString(selectedDate) || today}
                onChange={handleGantiTanggalKalender}
                filterDate={filterTanggal}
                minDate={minDate}
                maxDate={today}
                dateFormat="E, d MMM"
                locale="id"
                customInput={
                  <Input
                    size="xs"
                    bg="whiteAlpha.200"
                    borderColor="whiteAlpha.300"
                    color="white"
                    w={{ base: "90px", sm: "110px", md: "160px" }}
                    fontSize={{ base: "xs", md: "sm" }}
                    _hover={{ bg: "whiteAlpha.300" }}
                    cursor="pointer"
                    readOnly
                  />
                }
                popperPlacement="bottom-end"
              />

              {/* Email + Avatar - hidden di mobile */}
              <Flex align="center" gap={1} display={{ base: "none", md: "flex" }}>
                <Avatar size="xs" name={userEmail || "Guest"} />
                <Text fontSize="sm" fontWeight="bold" noOfLines={1} maxW="140px">
                  {userEmail}
                </Text>
              </Flex>

              {/* Tombol Kembali ke Dashboard */}
              <Button size="xs" leftIcon={<FaArrowLeft />} variant="outline" colorScheme="whiteAlpha" onClick={() => navigate("/dashboard")}>
  Kembali
</Button>

              {/* Toggle Dark/Light */}
              <IconButton
                size="xs"
                icon={colorMode === "light"? "🌙" : "☀️"}
                variant="outline"
                colorScheme="whiteAlpha"
                onClick={toggleColorMode}
                aria-label="Toggle theme"
              />
            </Flex>
          </Flex>
        </Box>

          <Flex direction="column" w="100%" p={4} ref={componentRef}>
         
              <Stack spacing={6}>
                <Flex justify="space-between" align="center" wrap="wrap" gap={4}>
                  <Text fontSize="2xl" fontWeight="bold">Ringkasan Aktivitas</Text>
                  <Flex gap={3}>
                    <ButtonGroup size="sm" isAttached variant="outline">
                      <IconButton icon={<BiBarChart />} onClick={() => setChartType('bar')} colorScheme={chartType === 'bar'? 'blue' : 'gray'} aria-label="Bar" />
                      <IconButton icon={<BiLineChart />} onClick={() => setChartType('line')} colorScheme={chartType === 'line'? 'blue' : 'gray'} aria-label="Line" />
                    </ButtonGroup>
                    <Select value={jumlahHari} onChange={handleGantiHari} w="180px" bg="white" isDisabled={isLoading}>
                      <option value={7}>7 hari terakhir</option>
                      <option value={14}>14 hari terakhir</option>
                      <option value={30}>30 hari terakhir</option>
                      <option value={90}>90 hari terakhir</option>
                      <option value={150}>150 hari terakhir</option>
                    </Select>
                  </Flex>
                </Flex>

                <Grid templateColumns={{ base: "1fr", sm: "1fr 1fr", lg: "repeat(5, 1fr)" }} gap={4}>
                  <GridItem bgGradient="linear(to-br, blue.400, blue.600)" p={4} rounded="xl" shadow="lg" color="white">
                    <Flex justify="space-between" align="start">
                      <Stat>
                        <StatLabel fontSize="sm" opacity={0.9}>
                          Langkah
                          <Text as="span" display="block" fontSize="xs" opacity={0.8} mt={0.5}>{selectedDate}</Text>
                        </StatLabel>
                        <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displaySteps}</StatNumber>
                      </Stat>
                      <Icon as={FaWalking} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                    </Flex>
                  </GridItem>

                  <GridItem bgGradient="linear(to-br, teal.400, teal.600)" p={4} rounded="xl" shadow="lg" color="white">
                    <Flex justify="space-between" align="start">
                      <Stat>
                        <StatLabel fontSize="sm" opacity={0.9}>
                          Poin Kardio
                          <Text as="span" display="block" fontSize="xs" opacity={0.8} mt={0.5}>{selectedDate}</Text>
                        </StatLabel>
                        <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayCardio}</StatNumber>
                      </Stat>
                      <Icon as={FaHeart} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                    </Flex>
                  </GridItem>

                  <GridItem bgGradient="linear(to-br, purple.400, purple.600)" p={4} rounded="xl" shadow="lg" color="white">
                    <Flex justify="space-between" align="start">
                      <Stat>
                        <StatLabel fontSize="sm" opacity={0.9}>Berat Badan</StatLabel>
                        <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayWeight} <Text as="span" fontSize="lg">kg</Text></StatNumber>
                      </Stat>
                      <Icon as={FaWeight} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                    </Flex>
                  </GridItem>

                  <GridItem bgGradient="linear(to-br, orange.400, orange.600)" p={4} rounded="xl" shadow="lg" color="white">
                    <Flex justify="space-between" align="start">
                      <Stat>
                        <StatLabel fontSize="sm" opacity={0.9}>Tinggi Badan</StatLabel>
                        <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayHeight} <Text as="span" fontSize="lg">cm</Text></StatNumber>
                      </Stat>
                      <Icon as={FaRulerVertical} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                    </Flex>
                  </GridItem>

                  <GridItem bgGradient="linear(to-br, pink.400, pink.600)" p={4} rounded="xl" shadow="lg" color="white">
                    <Flex justify="space-between" align="start">
                      <Stat>
                        <StatLabel fontSize="sm" opacity={0.9}>Detak Jantung</StatLabel>
                        <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayHeartRate} <Text as="span" fontSize="lg">bpm</Text></StatNumber>
                      </Stat>
                      <Icon as={FaHeartbeat} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                    </Flex>
                  </GridItem>
                </Grid>

                <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }}>
                    <Text fontWeight="bold" mb={3} textAlign="center" fontSize={{ base: "md", md: "lg" }}>
                      Body Mass Index - {selectedDate}
                    </Text>
                    <Box w="100%" maxW={{ base: "300px", sm: "350px", md: "400px" }} mx="auto">
                      <GaugeChart
                        id="bmi-gauge-meal"
                        nrOfLevels={5}
                        colors={["#3182CE", "#38A169", "#ECC94B", "#ED8936", "#E53E3E"]}
                        arcWidth={0.3}
                        percent={displayBmi? Math.min(displayBmi / 45, 1) : 0}
                        textColor={displayBmiColor}
                        needleColor="#2D3748"
                        needleBaseColor="#2D3748"
                        formatTextValue={() => displayBmi? displayBmi.toFixed(1) : '-'}
                        style={{ width: '100%', height: 'auto' }}
                        textComponentFontSize={24}
                        animate={true}
                        animDelay={0}
                      />
                      <Flex justify="space-between" fontSize={{ base: "2xs", sm: "xs" }} color="gray.500" mt={-2} px={{ base: 2, md: 4 }}>
                        <Text>15</Text><Text>18.5</Text><Text>25</Text><Text>30</Text><Text>40</Text><Text>45</Text>
                      </Flex>
                    </Box>
                    <Flex justify="center" mt={3}>
                      <Badge fontSize={{ base: "sm", md: "md" }} px={{ base: 3, md: 4 }} py={1} bg={displayBmiColor} color="white">
                        {displayBmiCategory || 'Tidak ada data'}
                      </Badge>
                    </Flex>
                    <Text fontSize={{ base: "xs", sm: "sm" }} textAlign="center" color="gray.600" mt={2}>
                      {displayWeight}kg / {displayHeight}cm - {selectedDate}
                    </Text>
                  </GridItem>

                  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }}>
                    <Text fontWeight="bold" mb={2}>Skor Kesehatan - {selectedDate}</Text>
                    <Flex align="center" gap={3}>
                      <Text fontSize="3xl" fontWeight="bold" color={`${displayHealthScore.color}.500`}>
                        {displayHealthScore.persen}
                      </Text>
                      <Badge colorScheme={displayHealthScore.color} fontSize="md">
                        {displayHealthScore.label}
                      </Badge>
                    </Flex>
                    <Progress value={displayHealthScore.persen} colorScheme={displayHealthScore.color} mt={2} borderRadius="md" />
                  </GridItem>
                </Grid>

                <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }}>
                  <Text fontWeight="bold" mb={3} textAlign="center">Perbandingan vs Standar WHO - {selectedDate}</Text>
                  <ResponsiveContainer width="100%" height={{ base: 350, md: 400 }}>
                    <BarChart data={healthDetail} layout="vertical" margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                      <CartesianGrid strokeDasharray="3 3" horizontal={false} opacity={0.2} />
                      <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
                      <YAxis dataKey="indikator" type="category" width={60} fontSize={12} />
                      <Tooltip formatter={(v, name, props) => [`${v}% (${props.payload.nilai}${props.payload.satuan})`, name]} />
                      <Legend />
                      <Bar dataKey="target" fill="#38A169" name="Target WHO" radius={[0, 4, 4, 0]} barSize={12} />
                      <Bar dataKey="aktual" fill="#3182CE" name="Skor Kamu" radius={[0, 4, 4, 0]} barSize={12} />
                    </BarChart>
                  </ResponsiveContainer>

                  <SimpleGrid columns={{ base: 1, md: 3 }} spacing={2} mt={4}>
                    {healthDetail.map(item => (
                      <Flex key={item.indikator} justify="space-between" p={2} bg={item.aktual >= 100? 'green.50' : item.aktual >= 60? 'orange.50' : 'red.50'} rounded="md">
                        <Text fontSize="sm" fontWeight="bold">{item.indikator}</Text>
                        <Badge colorScheme={item.aktual >= 100? 'green' : item.aktual >= 60? 'orange' : 'red'}>
                          {item.aktual}% / {item.nilai}{item.satuan}
                        </Badge>
                      </Flex>
                    ))}
                  </SimpleGrid>
                </GridItem>

                {/* HISTORY DARI DATABASE - BATASNYA SAMPAI SINI */}
                <Text fontSize="xl" fontWeight="bold" mt={4}>History dari Database</Text>
                <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md">
                    <Text fontWeight="bold" mb={3}>History BMI - {jumlahHari} Hari Terakhir</Text>
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={historyData}>
                        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                        <XAxis dataKey="tanggal" fontSize={10} interval={'preserveStartEnd'} />
                        <YAxis domain={[15, 40]} ticks={[15, 18.5, 25, 30, 40]} tickFormatter={(v) => v.toFixed(1)} />
                        <Tooltip formatter={(v, name, props) => [`${parseFloat(v).toFixed(1)} - ${props.payload.bmi_category}`, 'BMI']} labelFormatter={(label) => `Tanggal: ${label}`} />
                        <Legend />
                        <Line type="monotone" dataKey="bmi" stroke="#E53E3E" strokeWidth={3} dot={{ r: 3, fill: '#E53E3E' }} name="BMI" connectNulls={true} />
                        <ReferenceLine y={18.5} stroke="#3182CE" strokeDasharray="5 5" label={{ value: "Underweight", position: "insideTopLeft", fontSize: 10 }} />
                        <ReferenceLine y={25} stroke="#38A169" strokeDasharray="5 5" label={{ value: "Normal", position: "insideTopLeft", fontSize: 10 }} />
                        <ReferenceLine y={30} stroke="#ED8936" strokeDasharray="5 5" label={{ value: "Overweight", position: "insideTopLeft", fontSize: 10 }} />
                      </LineChart>
                    </ResponsiveContainer>
                  </GridItem>

                  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md">
                    <Text fontWeight="bold" mb={3}>History Skor Kesehatan - {jumlahHari} Hari Terakhir</Text>
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={historyData}>
                        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                        <XAxis dataKey="tanggal" fontSize={11} />
                        <YAxis domain={[0, 100]} />
                        <Tooltip formatter={(v, name, props) => [`${v} - ${props.payload.health_label}`, 'Skor']} />
                        <Bar dataKey="health_score" name="Skor" radius={[4, 4, 0, 0]}>
                          {historyData.map((entry, index) => {
                            let color = '#E53E3E';
                            if (entry.health_score >= 80) color = '#38A169';
                            else if (entry.health_score >= 60) color = '#319795';
                            else if (entry.health_score >= 40) color = '#DD6B20';
                            return <Cell key={`cell-${index}`} fill={color} />;
                          })}
                        </Bar>
                        <ReferenceLine y={80} stroke="#38A169" strokeDasharray="5 5" />
                        <ReferenceLine y={60} stroke="#319795" strokeDasharray="5 5" />
                        <ReferenceLine y={40} stroke="#DD6B20" strokeDasharray="5 5" />
                      </BarChart>
                    </ResponsiveContainer>
                  </GridItem>


{/* MEAL PLAN 8 HARI - 3 PILIHAN PER HARI + TOMBOL SIMPAN */}
{mealPlans.length > 0 && (



  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} mt={6} minH="600px">

{/* DIAGRAM TARGET KALORI 8 HARI */}
{mealPlans.length > 0 && (
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} mt={6}>
    <Text fontWeight="bold" mb={4} textAlign="center">
      Progress Meal Plan 8 Hari - Target vs Status
    </Text>

    {/* DIAGRAM TARGET KALORI 8 HARI - KLIK BATANG = SCROLL */}
{mealPlans.length > 0 && (
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} mt={6}>
    <Text fontWeight="bold" mb={4} textAlign="center">
      Klik Batang Untuk Scroll Ke Hari Tersebut
    </Text>

    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={mealPlans} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis
          dataKey="date"
          angle={-45}
          textAnchor="end"
          height={60}
          fontSize={11}
          tickFormatter={(value) => value.split(', ')[1]}
        />
        <YAxis tickFormatter={(v) => `${v} kkal`} fontSize={12} />
        <Tooltip
          cursor={{ fill: 'rgba(251, 146, 60, 0.2)' }} // hover effect orange
          formatter={(value, name, props) => {
            const idx = props.payload.day - 1;
            const sudahPilih = selectedMenus[idx]!== undefined;
            return [`${value} kkal - ${sudahPilih? 'Sudah dipilih' : 'Belum dipilih'}`, 'Target'];
          }}
          labelFormatter={(label) => `Tanggal: ${label}`}
        />

        <Bar
          dataKey="target"
          radius={[8, 8, 0, 0]}
          barSize={40}
          cursor="pointer" // <- kursor jadi tangan
        >
          {mealPlans.map((plan, index) => {
            const sudahPilih = selectedMenus[index]!== undefined;
            return (
              <Cell
                key={`cell-${index}`}
                fill={sudahPilih? '#38A169' : '#CBD5E0'}
                onClick={() => { // <- KLIK BATANG SCROLL KE HARI
                  dayRefs.current[index]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                  });
                }}
              />
            );
          })}
        </Bar>
      </BarChart>
    </ResponsiveContainer>

    <Flex justify="center" gap={4} mt={3} wrap="wrap">
      <Flex align="center" gap={2}>
        <Box w="20px" h="12px" bg="#38A169" rounded="sm" />
        <Text fontSize="sm">Sudah dipilih menu</Text>
      </Flex>
      <Flex align="center" gap={2}>
        <Box w="20px" h="12px" bg="#CBD5E0" rounded="sm" />
        <Text fontSize="sm">Belum dipilih - klik batang</Text>
      </Flex>
    </Flex>
  </GridItem>
)}

    <Flex justify="center" gap={4} mt={3}>
      <Flex align="center" gap={2}>
        <Box w="20px" h="12px" bg="#38A169" rounded="sm" />
        <Text fontSize="sm">Sudah ada menu</Text>
      </Flex>
      <Flex align="center" gap={2}>
        <Box w="20px" h="12px" bg="#CBD5E0" rounded="sm" />
        <Text fontSize="sm">Belum dipilih</Text>
      </Flex>
    </Flex>
  </GridItem>
)}

{/* GRAFIK 30 HARI - SCROLL HORIZONTAL BUAT HP */}
{plan30Hari.length > 0 && (
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} mt={6}>
    <Text fontWeight="bold" mb={2} textAlign="center">
      Roadmap Meal Plan 30 Hari Ke Depan
    </Text>
    <Text fontSize="xs" color="orange.600" mb={2} textAlign="center">
      Swipe kiri/kanan untuk lihat semua tanggal 👉
    </Text>

    {/* Wrapper scroll horizontal */}
    <Box overflowX="auto" overflowY="hidden" css={{
      '&::-webkit-scrollbar': { height: '6px' },
      '&::-webkit-scrollbar-thumb': { background: 'orange', borderRadius: '3px' }
    }}>
      {/* Lebar fix 1200px biar 30 batang gak gepeng */}
      <Box minW="1200px" h="320px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={plan30Hari} margin={{ top: 20, right: 20, left: 20, bottom: 80 }}>
            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
            <XAxis
              dataKey="date"
              angle={-60}
              textAnchor="end"
              height={80}
              fontSize={10}
              interval={0} // tampilkan semua tanggal
              tickFormatter={(value) => value.split(', ')[1]}
            />
            <YAxis tickFormatter={(v) => v > 0? `${v}` : ''} fontSize={11} domain={[0, 'dataMax + 200']} />
            <Tooltip
              cursor={{ fill: 'rgba(251, 146, 60, 0.15)' }}
              formatter={(value, name, props) => {
                if (value === 0) return ['Belum ada plan', 'Status'];
                const status = props.payload.sudahPilih? 'Menu dipilih' : 'Menu belum dipilih';
                return [`${value} kkal - ${status}`, 'Target'];
              }}
              labelFormatter={(label) => `Tanggal: ${label}`}
            />

            <Bar dataKey="target" barSize={28} radius={[4, 4, 0, 0]} cursor="pointer">
              {plan30Hari.map((item, index) => {
                let color = '#CBD5E0';
                if (item.adaPlan && item.sudahPilih) color = '#38A169';
                else if (item.adaPlan) color = '#ED8936';

                return (
                  <Cell
                    key={`cell-30-${index}`}
                    fill={color}
                    onClick={() => {
                      const plan8Hari = mealPlans.find(p => p.dateMySQL === item.dateMySQL);
                      if (plan8Hari) {
                        const idx = plan8Hari.day - 1;
                        dayRefs.current[idx]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      } else {
                        showToast(`Hari ${item.day} belum ada meal plan`, 'info');
                      }
                    }}
                  />
                );
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>

    <Flex justify="center" gap={3} mt={3} wrap="wrap" fontSize="xs">
      <Flex align="center" gap={1}>
        <Box w="14px" h="8px" bg="#38A169" rounded="sm" />
        <Text>Lengkap</Text>
      </Flex>
      <Flex align="center" gap={1}>
        <Box w="14px" h="8px" bg="#ED8936" rounded="sm" />
        <Text>Menu kosong</Text>
      </Flex>
      <Flex align="center" gap={1}>
        <Box w="14px" h="8px" bg="#CBD5E0" rounded="sm" />
        <Text>Belum ada plan</Text>
      </Flex>
    </Flex>
  </GridItem>
)}





    <Flex justify="space-between" align="center" mb={4} wrap="wrap" gap={2}>



      
      <Text fontWeight="bold" fontSize="lg">
        Pilih Meal Plan 8 Hari Ke Depan
      </Text>
      {!isExistingPlan && (
        <Text fontSize="sm" color="orange.500" fontWeight="600">
          Belum ada plan. Pilih menu lalu Simpan
        </Text>
      )}
      <Badge
  ml={3}
  colorScheme={isExistingPlan? "green" : "gray"}
  fontSize="sm"
  px={3}
  py={1}
>
  {isExistingPlan && planHeader
  ? `Meal Plan Ada - Tgl ${formatDateString(new Date(planHeader.start_date))} s/d ${formatDateString(new Date(planHeader.end_date))}`
   : 'Buat Plan Baru'
  }
</Badge>






    </Flex>

    {isLoading? (
      <Stack spacing={6}>
        {Array.from({length: 8}).map((_, i) => (
          <Box key={i} p={4} bg="whiteAlpha.300" rounded="lg" borderWidth="1px">
            <SkeletonText mb={3} noOfLines={1} w="40%" />
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
              {Array.from({length: 3}).map((_, j) => (
                <Box key={j} p={3} bg="whiteAlpha.200" rounded="md" h="180px">
                  <SkeletonText noOfLines={6} spacing={3} />
                </Box>
              ))}
            </SimpleGrid>
          </Box>
        ))}
      </Stack>
    ) : (
      <Stack spacing={6}>
        {mealPlans.map((plan, dayIdx) => (
          <Box
    ref={el => dayRefs.current[dayIdx] = el} // <- TAMBAH BARIS INI
    key={dayIdx}
    p={4}
    bg="whiteAlpha.500"
    rounded="lg"
    borderWidth="1px"
  >
            <Text fontWeight="bold" mb={3}>
              Hari {plan.day} - {plan.date} | Target: {plan.target} kkal
            </Text>

            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
              {(plan.menus || []).map((menu, menuIdx) => {
                const isSelected = selectedMenus?.[dayIdx] === menuIdx;
                return (
                  <Box key={menuIdx}
                    p={3}
                    bg={isSelected? 'orange.100' : 'whiteAlpha.400'}
                    borderWidth="2px"
                    borderColor={isSelected? 'orange.400' : 'transparent'}
                    rounded="md"
                    cursor="pointer"
                    onClick={() => setSelectedMenus(prev => ({...prev, [dayIdx]: menuIdx}))}
                    _hover={{ bg: 'orange.50' }}
                    minH="180px"
                  >
                    <Flex justify="space-between" mb={2}>
                      <Badge colorScheme={isSelected? 'orange' : 'gray'}>Menu {menuIdx + 1}</Badge>
                      <Text fontSize="xs" fontWeight="bold">{menu.total || 0} kkal</Text>
                    </Flex>

                    <Stack spacing={1}>
                      {(menu.items || []).map((item, i) => (
                        <Box key={i}>
                          <Flex justify="space-between">
                            <Text fontSize="xs" fontWeight="600">{item.waktu}</Text>
                            <Text fontSize="xs" color="orange.600">{item.kkal} kkal</Text>
                          </Flex>
                          <Text fontSize="xs" color="gray.700" noOfLines={2}>{item.menu}</Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                );
              })}
            </SimpleGrid>
          </Box>
        ))}
      </Stack>
    )}

    {/* Button pindah keluar Stack */}
    <Flex gap={3} mt={6}>
      <Button colorScheme="orange" size="lg" flex="1" onClick={handleSaveMealPlan} isLoading={savingMeal}>
        Simpan Meal Plan 8 Hari
      </Button>
      <Button colorScheme="red" variant="outline" size="lg" flex="0.5" onClick={handleDeleteMealPlan} isLoading={deletingMeal} isDisabled={mealPlans.length === 0}>
        Hapus
      </Button>
    </Flex>
  </GridItem>
)}


                </Grid>
              </Stack>
   
          </Flex>
        </Box>
      )}
    </>
  );
};

export default DashboardMeal;